import { Component, ElementRef, EventEmitter, Input, Output, inject } from '@angular/core';
import {Taak} from '../../../dienst/taak';
import {Dienst} from '../../../dienst/dienst';
import {Categorie} from '../../../dienst/categorie';
import {Prestatie} from '../../prestatie';
import UitgevoerdeTaak from '../../uitgevoerde-taak';
import {TaakGeschiedenis} from '../../../taakgeschiedenis/taak-geschiedenis';
import {TaakTipAantal} from '../../../tip/taak-tip-aantal';

@Component({
    selector: 'zah-prestatie-taken-select',
    templateUrl: './prestatie-taken-select.component.html',
    styleUrls: ['./prestatie-taken-select.component.scss'],
    standalone: false
})
export class PrestatieTakenSelectComponent {
  private hostElement = inject(ElementRef);

  @Input()
  prestatie: Prestatie;
  @Input()
  taakGeschiedenis: TaakGeschiedenis;
  @Input()
  dienst: Dienst;
  @Input()
  category: Categorie;
  @Input()
  taken: Array<Taak>;
  @Input()
  taakTipAantallen: Array<TaakTipAantal>;
  @Output()
  taakSelected: EventEmitter<UitgevoerdeTaak> = new EventEmitter<UitgevoerdeTaak>();
  @Output()
  taakDeselected: EventEmitter<UitgevoerdeTaak> = new EventEmitter<UitgevoerdeTaak>();
  @Output()
  tipsOpened: EventEmitter<[string, string, string]> = new EventEmitter<[string, string, string]>();

  scrollTop(): void {
    this.hostElement?.nativeElement.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  getTaakId(index: number, taak: Taak): string {
    return taak.getId();
  }

  getTipAantal(taak: Taak): string {
    const taakTipAantal = this.taakTipAantallen
      .find(tipAantal => tipAantal.hasTaakId(taak.getId()) && tipAantal.hasCategorieId(this.category.getId()));
    const totaalAantalTips = taakTipAantal?.getTotaalAantalTips();
    return totaalAantalTips ? `(${totaalAantalTips})` : '';
  }

  toggleTaak(taak: Taak): void {
    if (this.prestatie.isUitgevoerd(this.dienst.getId(), this.category.getId(), taak.getId())) {
      this.taakDeselected.emit(this.prestatie.getUitgevoerdeTaak(this.dienst.getId(), this.category.getId(), taak.getId()));
    } else {
      this.taakSelected.emit(UitgevoerdeTaak.new(this.dienst.getId(), this.category.getId(), taak.getId()));
    }
  }

  onOpenTips(taak: Taak): void {
    this.tipsOpened.emit([this.dienst.getId(), this.category.getId(), taak.getId()]);
  }
}
